import React from 'react'

import reactQuery from '../../_helpers/reactQuery'
import { filterService } from '../../_services'
import { SLIDE_FIELDS } from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

// Phase 3.2 — homepage-specific edit dialog. Same as Page.jsx but EXPOSES the
// homepage CMS fields (hero tagline, About Us body/image/alt, the four
// section intros, LocalBusiness) so the SEO/marketing team can edit them
// without the noise appearing on every other page edit.
//
// The /pages/homepage route is STATIC (no :id param), so resolve the
// homepage doc's Mongo _id first and hand it to AbstractDocument. Without
// this the editor fetched GET /v1/filters/undefined and never loaded — the
// homepage fields were uneditable from Phase 3.2 until this fix.
const Homepage = function () {
  const lookup = reactQuery.getQuery(
    'filters',
    { type: typeConstant.PAGE, id: 'homepage' },
    filterService.query
  )
  const doc = lookup.data?.documents?.[0]
  if (!doc)
    return (
      <span className="spanText">
        {lookup.isLoading ? 'Loading...' : 'Homepage page doc not found'}
      </span>
    )
  return (
    <AbstractDocument
      id={doc._id}
      singleCollectionName="Page"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'coverPhoto',
        'images',
        'videos',
        ...SLIDE_FIELDS,
      ]}
    />
  )
}
export default Homepage
